import { render, staticRenderFns } from "./GridOverlay.vue?vue&type=template&id=1636643e&scoped=true&"
import script from "./GridOverlay.vue?vue&type=script&lang=js&"
export * from "./GridOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GridOverlay.vue?vue&type=style&index=0&id=1636643e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636643e",
  null
  
)

export default component.exports